export default "__VITE_ASSET__CJcyZE79__"